'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var settings = process.env.config;

var getBaseUrlFromMeta = exports.getBaseUrlFromMeta = function getBaseUrlFromMeta() {
  if (document.querySelector('meta[name="api_base_url"]')) {
    var url = document.querySelector('meta[name="api_base_url"]').content;
    return url.replace("/api/v1", "").replace("/api/v2", "");
  };

  return false;
};

var getBaseUrl = function getBaseUrl() {
  if (getBaseUrlFromMeta()) return getBaseUrlFromMeta();
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (settings && process.env.NODE_ENV === 'development') return settings.base_url;

  return location.origin;
};

exports.default = {
  method: 'GET',
  path: '',
  baseURL: getBaseUrl(),
  data: {},
  timeout: 35000,
  content_type: 'application/json',
  accept_header: settings ? settings.v2.accept_header : 'application/vnd.api+json'
};